<div class="custom-tooltip" *ngIf="hiddenDeliveries?.length > 0">
    <app-delivery-number *ngFor="let delivery of hiddenDeliveries"
                         [deliveryNumber]="delivery.number"
                         [salesOrderNumber]="delivery.salesOrderNumber"
                         [stopType]="delivery.stopType"
                         [showSalesOrderInline]="true"
                         displayType="badge">
    </app-delivery-number>
</div>
